const isTest =
  location.href.includes("test.angrymiao.com") ||
  !location.href.includes(".angrymiao.com");
const authBase = `https://auth${isTest ? "-test" : ""}.angrymiao.com/api`;
const aiBase = `https://ai${isTest ? "-test" : ""}.angrymiao.com/api`;
const base = `https://diy${isTest ? "-test" : ""}.angrymiao.com/api`;

export default {
  userEdit: `https://www${isTest ? "-test" : ""}.angrymiao.com/user-edit/`, // 个人信息修改
  AMMasterHistory: `https://www${
    isTest ? "-test" : ""
  }.angrymiao.com/am-master-history/`, // 历史版本
  auth: `https://auth${isTest ? "-test" : ""}.angrymiao.com/`, // 登录页面
  authRefreshToken: `${authBase}/passport/refresh-token`, // 刷新登录 token
  authProfile: `${authBase}/profile`, // 获取当前用户 profile
  authUser: `${authBase}/user/:id`, // 获取指定用户 profile

  led: `${base}/led`, // 灯效配置
  ledX: `${base}/led/x/:id`, // 灯效配置详情
  likedLED: `${base}/like/led`, // 获取点赞灯效
  checkLEDLike: `${base}/like/led-check`, // 检查灯效点赞
  likeLED: `${base}/like/led-like`, // 灯效点赞
  unlikeLED: `${base}/like/led-unlike`, // 灯效取消点赞

  ledDraft: `${base}/led/draft`, // 灯效草稿

  comment: `${base}/comment`, // 评论配置
  commentCount: `${base}/comment/count`, // 灯效评论数

  historyVersion: `${base}/version-manager/history-version`, // 加载器历史版本

  chat: `${aiBase}/chat`, // 加载器历史版本
};
